import { render, staticRenderFns } from "./CalendarBand.vue?vue&type=template&id=50729322&scoped=true"
import script from "./CalendarBand.vue?vue&type=script&lang=js"
export * from "./CalendarBand.vue?vue&type=script&lang=js"
import style0 from "./CalendarBand.vue?vue&type=style&index=0&id=50729322&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50729322",
  null
  
)

export default component.exports